var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote"},[(_vm.data.label && _vm.data.label !== '')?_c('h3',[_vm._v(" "+_vm._s(_vm.data.label)+" ")]):_vm._e(),(_vm.data.content && _vm.data.content !== '')?_c('h2',[_vm._v(" "+_vm._s(_vm.data.content)+" ")]):_vm._e(),(_vm.data.cta)?_c('Cta',{attrs:{"data":{
      icon: 'arrow',
      title: _vm.data.cta.title,
      url: _vm.data.cta.url,
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }